import { Component, OnInit } from '@angular/core';
import { GlobalVariableService } from "../../variables/global-variable";
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { TranslateService } from "../../../common/variables/translate-service";
import { DrawFence } from '../../fence/DrawFence';
import { SC_Input } from '../../input/SC_Input';
import { Global } from '../../utilities/global';

@Component({
  selector: 'sen-app-header-info',
  templateUrl: './header-info.component.html',
  styleUrls: ['./header-info.component.scss']
})
export class HeaderInfoComponent implements OnInit {
  selectedProject$: Observable<any[]>;
  selectedPlan$: Observable<any[]>;
  selectedInverter$: Observable<any[]>;
  panelCount$: Observable<any[]>;
  selectedPanelCount: number = 0;
  planCapacity: number;
  panelCountUnSubscribe: Subscription;
  convertToLocalNumber: any = Global.convertToLocalNumber;
  // SC_Input.sModulPdc

  constructor(public global: GlobalVariableService, public translate: TranslateService, private store: Store<any>) {
    this.selectedProject$ = this.store.select(state => { return state.appData.selectedProject });
    this.selectedPlan$ = this.store.select(state => { return state.appData.selectedPlan });
    this.selectedInverter$ = this.store.select(state => { return state.appData.selectedInverter });
    this.panelCount$ = this.store.select(state => {
      return state.appData.panelCount
    });
    this.panelCountUnSubscribe = this.panelCount$.subscribe((data: any) => {
      this.selectedPanelCount = data.count;
      this.planCapacity = Global.getKW(data.count, parseInt(SC_Input.sModulPdc))
    });
  }

  ngOnInit(): void {
    if (!DrawFence.storeObj) DrawFence.storeObj = this.store;
  }

  ngOnDestroy() {
    this.panelCountUnSubscribe.unsubscribe();
  }
}
